import { render, staticRenderFns } from "./IngestRdrFileAction.vue?vue&type=template&id=76db7a24"
import script from "./IngestRdrFileAction.vue?vue&type=script&lang=js"
export * from "./IngestRdrFileAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports